import { useInject } from '@vk-hr-tek/core/ioc';
import { Socket } from '@vk-hr-tek/core/websocket';

import { useDispatch, useSubscriptionWithPollingFallback } from '@app/hooks';

import {
  USER_CERTIFICATE_TOPIC,
  USER_CHANGED_MESSAGE_TYPE,
} from '../constants';
import {
  applyCertificateStatusFromSocket,
  pollUserCertificate,
} from '../slice';
import { UserChangedPayload } from '../types';

const POLL_INTERVAL = 5000;

export const useCertificateStatusSubscription = () => {
  const dispatch = useDispatch();
  const socket = useInject(Socket);

  useSubscriptionWithPollingFallback({
    subscribe: () => {
      const handler = (payload: UserChangedPayload) => {
        if (payload.topic !== USER_CERTIFICATE_TOPIC) {
          return;
        }

        dispatch(applyCertificateStatusFromSocket(payload.certificate));
      };

      const unsubscribeListener = socket.on<UserChangedPayload>(
        USER_CHANGED_MESSAGE_TYPE,
        handler,
      );
      socket.subscribe(USER_CERTIFICATE_TOPIC);

      return () => {
        unsubscribeListener();
        socket.unsubscribe(USER_CERTIFICATE_TOPIC);
      };
    },
    poll: () => {
      dispatch(pollUserCertificate());
    },
    pollInterval: POLL_INTERVAL,
  });
};
